import { createContext } from 'react';
import { RolePermissions } from './types';

export const RolePermissionsContext = createContext<RolePermissions>(
  {} as RolePermissions
);
RolePermissionsContext.displayName = 'RolePermissions';
